<div class="container my-4">
    <h3>{{ 'search.title' | translate }}</h3>
    <p>{{ 'search.description' | translate }}</p>

    <app-filters-form [filters]="filters$ | async" [screenFilters]="screenFilters$ | async" [filtersConfig]="filtersConfig$ | async"
        (submitFilters)="searchWithFilters($event)"></app-filters-form>
</div>